import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { reset as resetForm } from 'redux-form';
import ExternalAccount, {
    actions as externalAccountActions,
} from '../../../../common/externalAccount';
import { actions as topUpActions } from '../../../../common/topUp';
import { selectors as transitionRouterSelectors } from '../../../../common/transitionRouter';
import { actions as bookmakersInfoActions } from '../../../../common/bookmakersInfo';
import { selectors as userInfoSelectors } from '../../../../common/userInfo';
import {
    actions as bookmakersListActions,
    selectors as bookmakersListSelectors,
} from '../../../../common/bookmakersList';
import { actions as loginActions } from '../../../../common/loginPage';
import AccountInfoIntegrated from './components/AccountInfoIntegrated';
import { deleteLoginCookie } from '../../../../common/utils/loginCookies';
import './styles.scss';
import { skybetDiffusionName } from '../../../../common/utils/skybetMigration';

export class AccountInfoPage extends Component {
    static defaultProps = {
        isLoggedIn: false,
        isBalanceVisible: true,
        isTopUpModalVisible: false,
        isTopUpIntegrated: false,
        isExternalAccount: false,
        accountType: 'iframe',
        withdrawBookmakerUrl: '',
        withdrawBookmakerName: '',
        topUpBookmakerUrl: '',
        topUpBookmakerName: '',
        forgottenPhoneNumber: '',
        cardDetails: null,
        isCardDetailsError: false,
        topUpErrorInfo: null,
        externalAccountUrl: '',
        isExternalAccountError: false,
        isExternalLogout: false,
    }

    static propTypes = {
        isLoggedIn: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        feed: PropTypes.string.isRequired,
        apiName: PropTypes.string.isRequired,
        cookieName: PropTypes.string.isRequired,
        isTopUpIntegrated: PropTypes.bool,
        externalAccountUrl: PropTypes.string,
        isExternalAccount: PropTypes.bool,
        accountType: PropTypes.string,
        isExternalAccountError: PropTypes.bool,
        isBalanceVisible: PropTypes.bool,
        isTopUpModalVisible: PropTypes.bool,
        toggleBalanceVisibility: PropTypes.func.isRequired,
        hideTopUpModal: PropTypes.func.isRequired,
        currencySign: PropTypes.string.isRequired,
        withdrawBookmakerUrl: PropTypes.string,
        withdrawBookmakerName: PropTypes.string,
        topUpBookmakerUrl: PropTypes.string,
        topUpBookmakerName: PropTypes.string,
        forgottenPhoneNumber: PropTypes.string,
        cardDetails: PropTypes.shape({
            cardId: PropTypes.string,
            cardNumber: PropTypes.string,
        }),
        isCardDetailsError: PropTypes.bool,
        topUpErrorInfo: PropTypes.shape({
            code: PropTypes.string,
        }),
        isPhone: PropTypes.bool.isRequired,
        getCardDetails: PropTypes.func.isRequired,
        topUpAccountBalance: PropTypes.func.isRequired,
        getUserInfo: PropTypes.func.isRequired,
        requestLogout: PropTypes.func.isRequired,
        setLoggedOut: PropTypes.func.isRequired,
        theme: PropTypes.shape({
            checkboxIconType: PropTypes.string,
        }).isRequired,
        getExternalAccountUrl: PropTypes.func.isRequired,
        clearExternalAccountData: PropTypes.func.isRequired,
        resetTopUpForm: PropTypes.func.isRequired,
        isExternalLogout: PropTypes.bool,
    }

    constructor(props) {
        super(props);
        this.state = {
            shouldRedirectToAccountSwitcher: false,
        };
    }

    componentWillMount() {
        const {
            apiName,
            getExternalAccountUrl,
            isExternalAccount,
        } = this.props

        if (isExternalAccount) {
            getExternalAccountUrl(apiName)
        }
    }

    onExternalLogout = () => {
        const {
            requestLogout,
            apiName,
            feed,
            isExternalLogout,
            setLoggedOut,
            cookieName,
         } = this.props;
        this.setState({ isRedirectToSwitcherAllowed: false });
        if (feed === skybetDiffusionName) {
            deleteLoginCookie(cookieName);
            return setLoggedOut(feed);
        }

        return requestLogout(apiName, feed, isExternalLogout);
    }

    redirectToAccountSwitcher = () => {
        const { name, feed, getUserInfo } = this.props;
        getUserInfo(name, feed);
        this.setState({ shouldRedirectToAccountSwitcher: true });
    }

    render() {
        const {
            isLoggedIn,
            isTopUpIntegrated,
            isBalanceVisible,
            isTopUpModalVisible,
            externalAccountUrl,
            isExternalAccountError,
            isExternalAccount,
            accountType,
            hideTopUpModal,
            withdrawBookmakerUrl,
            withdrawBookmakerName,
            topUpBookmakerUrl,
            topUpBookmakerName,
            forgottenPhoneNumber,
            topUpAccountBalance,
            currencySign,
            cardDetails,
            isCardDetailsError,
            topUpErrorInfo,
            feed,
            theme,
            isPhone,
            apiName,
            getUserInfo,
            toggleBalanceVisibility,
            getCardDetails,
            requestLogout,
            isExternalLogout,
            resetTopUpForm,
        } = this.props;

        if (!isLoggedIn || this.state.shouldRedirectToAccountSwitcher) {
            return (<Redirect to={{
                pathname: '/',
                state: { isReversedAnimation: true },
            }}
            />);
        }

        return isExternalAccount ? (
            <ExternalAccount
                type={accountType}
                windowName={'Account'}
                externalAccountUrl={externalAccountUrl}
                isExternalAccountError={isExternalAccountError}
                onExternalBackButtonClick={this.redirectToAccountSwitcher}
                onLogout={this.onExternalLogout}
                onServerError={this.redirectToAccountSwitcher}
            />
        ) : (
            <AccountInfoIntegrated
                isTopUpIntegrated={isTopUpIntegrated}
                isBalanceVisible={isBalanceVisible}
                isTopUpModalVisible={isTopUpModalVisible}
                hideTopUpModal={hideTopUpModal}
                withdrawBookmakerUrl={withdrawBookmakerUrl}
                withdrawBookmakerName={withdrawBookmakerName}
                topUpBookmakerUrl={topUpBookmakerUrl}
                topUpBookmakerName={topUpBookmakerName}
                topUpPhoneNumber={forgottenPhoneNumber}
                topUpAccountBalance={topUpAccountBalance}
                currencySign={currencySign}
                cardDetails={cardDetails}
                isCardDetailsError={isCardDetailsError}
                topUpErrorInfo={topUpErrorInfo}
                feed={feed}
                theme={theme}
                isPhone={isPhone}
                apiName={apiName}
                getUserInfo={getUserInfo}
                toggleBalanceVisibility={toggleBalanceVisibility}
                requestLogout={requestLogout}
                isExternalLogout={isExternalLogout}
                getCardDetails={getCardDetails}
                resetTopUpForm={resetTopUpForm}
            />
        );
    }
}

const showBalanceSelector =
    userInfoSelectors.createShowBalanceSelector(
        transitionRouterSelectors.feedSelector,
    );

const userCurrencySignSelector =
    userInfoSelectors.createUserCurrencySignSelector(
        transitionRouterSelectors.feedSelector,
    );

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        transitionRouterSelectors.feedSelector,
    );

const mapStateToProps = (state, props) => {
    const {
        isTopUpModalVisible,
        topUpErrorInfo,
        cardDetails,
        isCardDetailsError,
    } = state.topUp;
    const {
        isExternalAccountError,
        externalAccountUrl,
    } = state.externalAccount;
    return {
        ...bookmakerInfoSelector(state, props),
        currencySign: userCurrencySignSelector(state, props),
        feed: transitionRouterSelectors.feedSelector(state, props),
        isBalanceVisible: showBalanceSelector(state, props),
        isTopUpModalVisible,
        cardDetails,
        isCardDetailsError,
        topUpErrorInfo,
        isExternalAccountError,
        externalAccountUrl,
        isPhone: state.pageInfo.isPhone,
    };
};

const mapDispatchToProps = {
    hideTopUpModal: topUpActions.hideTopUpModal,
    toggleBalanceVisibility: bookmakersInfoActions.toggleBalanceVisibility,
    getCardDetails: topUpActions.getCardDetails,
    topUpAccountBalance: topUpActions.topUpAccountBalance,
    getUserInfo: bookmakersListActions.getUserInfo,
    requestLogout: loginActions.requestLogout,
    getExternalAccountUrl: externalAccountActions.getExternalAccountUrl,
    clearExternalAccountData: externalAccountActions.clearExternalAccountData,
    resetTopUpForm: resetForm.bind(null, 'topUpForm'),
    setLoggedOut: bookmakersListActions.setLoggedOut,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AccountInfoPage);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/accountInfo/AccountInfoPage.jsx